import { useCallback, useState } from "react"
import { LEFT_PANEL_WIDTH } from "@/config/layout"

// Resizable left-panel width (dragged on the right edge), persisted per
// storageKey. Shared by the vessel, voyage-planner and RNW panels.
export default function usePanelWidth({ storageKey, map, panelRef }) {
  const [panelWidth, setPanelWidth] = useState(() => {
    const stored = Number(
      typeof window !== "undefined"
        ? window.localStorage?.getItem(storageKey)
        : null,
    )
    return Number.isFinite(stored) && stored >= LEFT_PANEL_WIDTH
      ? stored
      : LEFT_PANEL_WIDTH
  })

  const handleResizeMouseDown = useCallback(
    (e) => {
      e.preventDefault()
      e.stopPropagation()
      const startX = e.clientX
      const startWidth = panelRef.current?.offsetWidth ?? panelWidth
      const maxWidth = Math.max(LEFT_PANEL_WIDTH, window.innerWidth - 120)
      map?.dragging?.disable()

      const onMove = (ev) => {
        let next = startWidth + (ev.clientX - startX)
        if (next < LEFT_PANEL_WIDTH) next = LEFT_PANEL_WIDTH
        if (next > maxWidth) next = maxWidth
        setPanelWidth(next)
      }
      const onUp = () => {
        document.removeEventListener("mousemove", onMove)
        document.removeEventListener("mouseup", onUp)
        map?.dragging?.enable()
        setPanelWidth((w) => {
          window.localStorage?.setItem(storageKey, String(w))
          return w
        })
      }
      document.addEventListener("mousemove", onMove)
      document.addEventListener("mouseup", onUp)
    },
    [map, panelWidth, panelRef, storageKey],
  )

  return { panelWidth, handleResizeMouseDown }
}
